
export default {
    setToken(token) {
        localStorage.setItem('AUTHENTICATION_TOKEN', token);
    },
    getToken () {
        return localStorage.getItem('AUTHENTICATION_TOKEN');
    },
    clearToken () {
        localStorage.removeItem('AUTHENTICATION_TOKEN');
    }
}